/* eslint-disable react/react-in-jsx-scope */
import Cell from "./components/Structure/components/Cell";
import { ACCESSORS, WIDTH, ID } from "./constants.js";
import MainColumn from "./components/Structure/components/MainColumn";
import ArticleCell from "./components/Structure/components/ArticleCell";
import { getAccessor } from "./functions";

export const getColumns = () => {
  return [
    {
      Header: () => null,
      id: ID,
      columns: [
        {
          Header: () => <MainColumn />,
          id: "articleName",
          accessor: (row) => getAccessor(row),
          Cell: ({ value, row }) => <ArticleCell row={row} value={value} />,
          width: WIDTH,
        },
        {
          Header: () => null,
          accessor: ACCESSORS[1],
          Cell: ({ value }) => <Cell show={true} value={"$ " + value} />,
        },
      ],
    },
  ];
};
